import { getConfig } from "core/utilities";
import "firebase/compat/auth";
import "firebase/compat/database";
import useUrlParams from "hooks/useUrlParams";
import { useEffect } from "react";
import useDimensions from "react-cool-dimensions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { Spinner } from "reactstrap";
import { initUI } from "resbutler-ui/init";
import { StateType } from "store/reducers/reducers";
import useLabels from "../../hooks/useLabels";
import useMenus from "../../hooks/useMenus";
import useOperators from "../../hooks/useOperators";
import useProductAmmendments from "../../hooks/useProductAmmendments";
import useRestaurants from "../../hooks/useRestaurants";
import useUser from "../../hooks/useUser";
import { setOMSWidth } from "../../store/reducers/rootSlice";
import Offsidebar from "./Offsidebar";
import OmsHeader from "./OmsHeader";
import OmsSelector from "./OmsSelector";

const Base = (props) => {
  const { restaurants } = useSelector((state: StateType) => {
    return {
      restaurants: state.root.restaurants,
    };
  }, shallowEqual);
  const [loading] = useUser();
  const [loadingMenus] = useMenus(loading);
  useProductAmmendments(loading);
  useRestaurants(loading);
  useOperators(loading);
  useLabels(loading);
  initUI(getConfig());
  const dispatch = useDispatch();
  const { observe, width: omsWidth } = useDimensions();
  const [restaurantId] = useUrlParams();

  useEffect(() => {
    if (restaurants?.[restaurantId]) window.document.title = `OMS - ${restaurants[restaurantId].name}`;
    else window.document.title = "OMS";
  }, [restaurants, restaurantId]);

  useEffect(() => {
    dispatch(setOMSWidth(Math.floor(omsWidth)));
  }, [omsWidth]);

  if (loading || loadingMenus) {
    return (
      <div className="text-center" style={{ padding: "30px 0" }}>
        <Spinner size="lg" color="white">
          {""}
        </Spinner>
      </div>
    );
  }
  return (
    <div className="wrapper oms">
      <OmsHeader {...props} />
      <div ref={observe} style={{ margin: "0 10px" }}>
        <OmsSelector {...props} />
      </div>
      <section className="section-container" style={{ marginTop: "-10px", marginLeft: "10px", marginRight: "10px" }}>
        {props.children}
      </section>
      <Offsidebar />
      <ToastContainer autoClose={3000} pauseOnFocusLoss={false} />
    </div>
  );
};

export default Base;
